
import { useState } from 'react';
import Logo from '../../../components/base/Logo';
import LogoUploader from '../../../components/base/LogoUploader';

const LinkbuildingPage = () => {
  // Original logo state handling
  const [logo, setLogo] = useState('');
  const [showLogoUploader, setShowLogoUploader] = useState(false);

  const handleLogoChange = (logoUrl: string) => {
    setLogo(logoUrl);
    setShowLogoUploader(false);
    // Сохраняем логотип в localStorage для сохранения между сессиями
    if (logoUrl) {
      localStorage.setItem('siteLogo', logoUrl);
    } else {
      localStorage.removeItem('siteLogo');
    }
  };

  // Загружаем логотип при инициализации
  useState(() => {
    const savedLogo = localStorage.getItem('siteLogo');
    if (savedLogo) {
      setLogo(savedLogo);
    }
  });

  // Form handling
  const [formData, setFormData] = useState({
    name: '',
    email: '',
    phone: '',
    website: '',
    message: ''
  });

  const handleSubmit = (e: React.FormEvent) => {
    e.preventDefault();
    console.log('Form submitted:', formData);
  };

  const handleChange = (e: React.ChangeEvent<HTMLInputElement | HTMLTextAreaElement>) => {
    setFormData({
      ...formData,
      [e.target.name]: e.target.value
    });
  };

  return (
    <div className="min-h-screen bg-white">
      {/* Navigation */}
      <nav className="fixed top-0 left-0 right-0 bg-white/95 backdrop-blur-sm border-b border-gray-200 z-50">
        <div className="container mx-auto px-6">
          <div className="flex items-center justify-between h-16">
            <Logo />

            {/* existing navigation content */}
            <div className="hidden md:flex space-x-8">
              <a href="/" className="text-gray-700 hover:text-blue-600 transition-colors cursor-pointer">
                Главная
              </a>
              <a href="/blog" className="text-gray-700 hover:text-blue-600 transition-colors cursor-pointer">
                Блог
              </a>
              <a href="#services" className="text-gray-700 hover:text-blue-600 transition-colors cursor-pointer">
                Услуги
              </a>
              <a href="#contact" className="text-gray-700 hover:text-blue-600 transition-colors cursor-pointer">
                Контакты
              </a>
            </div>
          </div>
        </div>
      </nav>

      {/* Logo Uploader Modal */}
      {showLogoUploader && (
        <div className="fixed inset-0 bg-black/50 flex items-center justify-center z-50 p-4">
          <div className="bg-white rounded-xl p-6 max-w-md w-full">
            <div className="flex items-center justify-between mb-6">
              <h3 className="text-xl font-bold text-gray-900">Загрузить логотип</h3>
              <button
                onClick={() => setShowLogoUploader(false)}
                className="text-gray-400 hover:text-gray-600 cursor-pointer"
              >
                <i className="ri-close-line text-2xl"></i>
              </button>
            </div>

            <LogoUploader onLogoChange={handleLogoChange} currentLogo={logo} />

            <div className="mt-6 flex gap-3">
              <button
                onClick={() => setShowLogoUploader(false)}
                className="flex-1 bg-gray-100 hover:bg-gray-200 text-gray-700 py-2 px-4 rounded-lg font-semibold transition-colors whitespace-nowrap cursor-pointer"
              >
                Отмена
              </button>
            </div>
          </div>
        </div>
      )}

      {/* Hero Section */}
      <section className="relative bg-gradient-to-br from-green-50 to-emerald-100 py-20">
        <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
          <div className="grid grid-cols-1 lg:grid-cols-2 gap-12 items-center">
            <div>
              <h1 className="text-4xl lg:text-5xl font-bold text-gray-900 mb-6">
                Линкбилдинг и наращивание ссылочной массы
              </h1>
              <p className="text-xl text-gray-600 mb-8">
                Получаем качественные ссылки с авторитетных сайтов для роста позиций в поисковых системах.
              </p>
              <div className="flex flex-col sm:flex-row gap-4">
                <button className="bg-green-600 text-white px-8 py-3 rounded-lg hover:bg-green-700 transition-colors whitespace-nowrap cursor-pointer">
                  Заказать ссылки
                </button>
                <button className="border border-green-600 text-green-600 px-8 py-3 rounded-lg hover:bg-green-50 transition-colors whitespace-nowrap cursor-pointer">
                  Анализ ссылок
                </button>
              </div>
            </div>
            <div className="relative">
              <img
                src="https://readdy.ai/api/search-image?query=Professional%20SEO%20specialist%20working%20on%20link%20building%20strategy%2C%20network%20connections%20visualization%2C%20modern%20office%20with%20multiple%20screens%20showing%20backlink%20analysis%20and%20outreach%20campaigns%2C%20green%20and%20emerald%20color%20scheme%2C%20digital%20marketing%20atmosphere&width=600&height=400&seq=linkbuilding-hero&orientation=landscape"
                alt="Линкбилдинг"
                className="rounded-lg shadow-xl object-top"
              />
            </div>
          </div>
        </div>
      </section>

      {/* Link Types */}
      <section className="py-20 bg-white">
        <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
          <div className="text-center mb-16">
            <h2 className="text-3xl lg:text-4xl font-bold text-gray-900 mb-4">
              Типы ссылок, которые мы размещаем
            </h2>
            <p className="text-xl text-gray-600 max-w-3xl mx-auto">
              Работаем только с качественными площадками с высоким трастом
            </p>
          </div>

          <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-8">
            <div className="bg-gray-50 p-8 rounded-xl">
              <div className="w-12 h-12 bg-green-100 rounded-lg flex items-center justify-center mb-6">
                <i className="ri-newspaper-line text-2xl text-green-600"></i>
              </div>
              <h3 className="text-xl font-semibold text-gray-900 mb-4">Статейные ссылки</h3>
              <p className="text-gray-600 mb-4">
                Размещение ссылок в тематических статьях на авторитетных сайтах
              </p>
              <ul className="text-sm text-gray-500 space-y-2">
                <li>• Новостные порталы</li>
                <li>• Тематические блоги</li>
                <li>• Отраслевые издания</li>
                <li>• Экспертные площадки</li>
              </ul>
            </div>

            <div className="bg-gray-50 p-8 rounded-xl">
              <div className="w-12 h-12 bg-blue-100 rounded-lg flex items-center justify-center mb-6">
                <i className="ri-folder-line text-2xl text-blue-600"></i>
              </div>
              <h3 className="text-xl font-semibold text-gray-900 mb-4">Каталоги</h3>
              <p className="text-gray-600 mb-4">
                Размещение в качественных каталогах и справочниках
              </p>
              <ul className="text-sm text-gray-500 space-y-2">
                <li>• Бизнес-каталоги</li>
                <li>• Отраслевые справочники</li>
                <li>• Региональные каталоги</li>
                <li>• Тематические рубрикаторы</li>
              </ul>
            </div>

            <div className="bg-gray-50 p-8 rounded-xl">
              <div className="w-12 h-12 bg-purple-100 rounded-lg flex items-center justify-center mb-6">
                <i className="ri-discuss-line text-2xl text-purple-600"></i>
              </div>
              <h3 className="text-xl font-semibold text-gray-900 mb-4">Форумы</h3>
              <p className="text-gray-600 mb-4">
                Естественные ссылки в обсуждениях на тематических форумах
              </p>
              <ul className="text-sm text-gray-500 space-y-2">
                <li>• Профессиональные форумы</li>
                <li>• Отраслевые сообщества</li>
                <li>• Q&amp;A площадки</li>
                <li>• Экспертные дискуссии</li>
              </ul>
            </div>

            <div className="bg-gray-50 p-8 rounded-xl">
              <div className="w-12 h-12 bg-orange-100 rounded-lg flex items-center justify-center mb-6">
                <i className="ri-share-line text-2xl text-orange-600"></i>
              </div>
              <h3 className="text-xl font-semibold text-gray-900 mb-4">Соцсети</h3>
              <p className="text-gray-600 mb-4">
                Продвижение через социальные сети и блог-платформы
              </p>
              <ul className="text-sm text-gray-500 space-y-2">
                <li>• ВКонтакте, Facebook</li>
                <li>• Telegram каналы</li>
                <li>• YouTube описания</li>
                <li>• Профессиональные сети</li>
              </ul>
            </div>

            <div className="bg-gray-50 p-8 rounded-xl">
              <div className="w-12 h-12 bg-red-100 rounded-lg flex items-center justify-center mb-6">
                <i className="ri-star-line text-2xl text-red-600"></i>
              </div>
              <h3 className="text-xl font-semibold text-gray-900 mb-4">Отзывы</h3>
              <p className="text-gray-600 mb-4">
                Размещение отзывов с ссылками на специализированных площадках
              </p>
              <ul className="text-sm text-gray-500 space-y-2">
                <li>• Отзовики</li>
                <li>• Рейтинговые сайты</li>
                <li>• Площадки услуг</li>
                <li>• Маркетплейсы</li>
              </ul>
            </div>

            <div className="bg-gray-50 p-8 rounded-xl">
              <div className="w-12 h-12 bg-indigo-100 rounded-lg flex items-center justify-center mb-6">
                <i className="ri-handshake-line text-2xl text-indigo-600"></i>
              </div>
              <h3 className="text-xl font-semibold text-gray-900 mb-4">Партнерские</h3>
              <p className="text-gray-600 mb-4">
                Взаимовыгодный обмен ссылками с партнерами
              </p>
              <ul className="text-sm text-gray-500 space-y-2">
                <li>• Партнеры по бизнесу</li>
                <li>• Поставщики и клиенты</li>
                <li>• Отраслевые ассоциации</li>
                <li>• Профессиональные союзы</li>
              </ul>
            </div>
          </div>
        </div>
      </section>

      {/* Process */}
      <section className="py-20 bg-gray-50">
        <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
          <div className="text-center mb-16">
            <h2 className="text-3xl lg:text-4xl font-bold text-gray-900 mb-4">
              Как мы работаем с ссылками
            </h2>
            <p className="text-xl text-gray-600">
              Пошаговый процесс наращивания ссылочной массы
            </p>
          </div>

          <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-4 gap-8">
            <div className="text-center">
              <div className="w-16 h-16 bg-green-600 text-white rounded-full flex items-center justify-center text-2xl font-bold mx-auto mb-6">
                1
              </div>
              <h3 className="text-xl font-semibold text-gray-900 mb-4">Анализ</h3>
              <p className="text-gray-600">
                Анализируем текущую ссылочную массу и конкурентов
              </p>
            </div>

            <div className="text-center">
              <div className="w-16 h-16 bg-green-600 text-white rounded-full flex items-center justify-center text-2xl font-bold mx-auto mb-6">
                2
              </div>
              <h3 className="text-xl font-semibold text-gray-900 mb-4">Стратегия</h3>
              <p className="text-gray-600">
                Разрабатываем стратегию линкбилдинга под ваши цели
              </p>
            </div>

            <div className="text-center">
              <div className="w-16 h-16 bg-green-600 text-white rounded-full flex items-center justify-center text-2xl font-bold mx-auto mb-6">
                3
              </div>
              <h3 className="text-xl font-semibold text-gray-900 mb-4">Размещение</h3>
              <p className="text-gray-600">
                Размещаем ссылки на качественных площадках
              </p>
            </div>

            <div className="text-center">
              <div className="w-16 h-16 bg-green-600 text-white rounded-full flex items-center justify-center text-2xl font-bold mx-auto mb-6">
                4
              </div>
              <h3 className="text-xl font-semibold text-gray-900 mb-4">Контроль</h3>
              <p className="text-gray-600">
                Отслеживаем результаты и корректируем стратегию
              </p>
            </div>
          </div>
        </div>
      </section>

      {/* Pricing */}
      <section className="py-20 bg-white">
        <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
          <div className="text-center mb-16">
            <h2 className="text-3xl lg:text-4xl font-bold text-gray-900 mb-4">
              Тарифы на линкбилдинг
            </h2>
            <p className="text-xl text-gray-600">
              Выберите подходящий пакет ссылок
            </p>
          </div>

          <div className="grid grid-cols-1 md:grid-cols-3 gap-8">
            <div className="bg-white border border-gray-200 rounded-xl p-8">
              <h3 className="text-2xl font-bold text-gray-900 mb-4">Стартовый</h3>
              <div className="text-4xl font-bold text-green-600 mb-6">
                20 000 ₽
                <span className="text-lg text-gray-500 font-normal">/мес</span>
              </div>
              <ul className="space-y-4 mb-8">
                <li className="flex items-center">
                  <i className="ri-check-line text-green-500 mr-3"></i>
                  <span>10 ссылок в месяц</span>
                </li>
                <li className="flex items-center">
                  <i className="ri-check-line text-green-500 mr-3"></i>
                  <span>Анализ ссылочной массы</span>
                </li>
                <li className="flex items-center">
                  <i className="ri-check-line text-green-500 mr-3"></i>
                  <span>Каталоги и справочники</span>
                </li>
                <li className="flex items-center">
                  <i className="ri-check-line text-green-500 mr-3"></i>
                  <span>Отчеты по размещению</span>
                </li>
                <li className="flex items-center">
                  <i className="ri-check-line text-green-500 mr-3"></i>
                  <span>Мониторинг ссылок</span>
                </li>
              </ul>
              <button className="w-full bg-green-600 text-white py-3 rounded-lg hover:bg-green-700 transition-colors whitespace-nowrap cursor-pointer">
                Выбрать тариф
              </button>
            </div>

            <div className="bg-green-50 border-2 border-green-600 rounded-xl p-8 relative">
              <div className="absolute -top-4 left-1/2 transform -translate-x-1/2">
                <span className="bg-green-600 text-white px-4 py-2 rounded-full text-sm font-medium">
                  Популярный
                </span>
              </div>
              <h3 className="text-2xl font-bold text-gray-900 mb-4">Профессиональный</h3>
              <div className="text-4xl font-bold text-green-600 mb-6">
                40 000 ₽
                <span className="text-lg text-gray-500 font-normal">/мес</span>
              </div>
              <ul className="space-y-4 mb-8">
                <li className="flex items-center">
                  <i className="ri-check-line text-green-500 mr-3"></i>
                  <span>25 ссылок в месяц</span>
                </li>
                <li className="flex items-center">
                  <i className="ri-check-line text-green-500 mr-3"></i>
                  <span>Статейные ссылки</span>
                </li>
                <li className="flex items-center">
                  <i className="ri-check-line text-green-500 mr-3"></i>
                  <span>Форумы и соцсети</span>
                </li>
                <li className="flex items-center">
                  <i className="ri-check-line text-green-500 mr-3"></i>
                  <span>Анализ конкурентов</span>
                </li>
                <li className="flex items-center">
                  <i className="ri-check-line text-green-500 mr-3"></i>
                  <span>Персональный менеджер</span>
                </li>
                <li className="flex items-center">
                  <i className="ri-check-line text-green-500 mr-3"></i>
                  <span>Детальные отчеты</span>
                </li>
              </ul>
              <button className="w-full bg-green-600 text-white py-3 rounded-lg hover:bg-green-700 transition-colors whitespace-nowrap cursor-pointer">
                Выбрать тариф
              </button>
            </div>

            <div className="bg-white border border-gray-200 rounded-xl p-8">
              <h3 className="text-2xl font-bold text-gray-900 mb-4">Корпоративный</h3>
              <div className="text-4xl font-bold text-green-600 mb-6">
                80 000 ₽
                <span className="text-lg text-gray-500 font-normal">/мес</span>
              </div>
              <ul className="space-y-4 mb-8">
                <li className="flex items-center">
                  <i className="ri-check-line text-green-500 mr-3"></i>
                  <span>50+ ссылок в месяц</span>
                </li>
                <li className="flex items-center">
                  <i className="ri-check-line text-green-500 mr-3"></i>
                  <span>Премиум площадки</span>
                </li>
                <li className="flex items-center">
                  <i className="ri-check-line text-green-500 mr-3"></i>
                  <span>Партнерские ссылки</span>
                </li>
                <li className="flex items-center">
                  <i className="ri-check-line text-green-500 mr-3"></i>
                  <span>Создание контента</span>
                </li>
                <li className="flex items-center">
                  <i className="ri-check-line text-green-500 mr-3"></i>
                  <span>Команда экспертов</span>
                </li>
                <li className="flex items-center">
                  <i className="ri-check-line text-green-500 mr-3"></i>
                  <span>Приоритетная поддержка</span>
                </li>
              </ul>
              <button className="w-full bg-green-600 text-white py-3 rounded-lg hover:bg-green-700 transition-colors whitespace-nowrap cursor-pointer">
                Выбрать тариф
              </button>
            </div>
          </div>
        </div>
      </section>

      {/* Contact Form */}
      <section id="contact" className="py-20 bg-gray-50">
        <div className="max-w-4xl mx-auto px-4 sm:px-6 lg:px-8">
          <div className="text-center mb-12">
            <h2 className="text-3xl lg:text-4xl font-bold text-gray-900 mb-4">
              Начать линкбилдинг
            </h2>
            <p className="text-xl text-gray-600">
              Получите анализ ссылочной массы и персональную стратегию
            </p>
          </div>

          <div className="bg-white rounded-xl shadow-lg p-8">
            <form onSubmit={handleSubmit} className="space-y-6">
              <div className="grid grid-cols-1 md:grid-cols-2 gap-6">
                <div>
                  <label htmlFor="name" className="block text-sm font-medium text-gray-700 mb-2">
                    Ваше имя *
                  </label>
                  <input
                    type="text"
                    id="name"
                    name="name"
                    value={formData.name}
                    onChange={handleChange}
                    required
                    className="w-full px-4 py-3 border border-gray-300 rounded-lg focus:ring-2 focus:ring-green-500 focus:border-transparent text-sm"
                    placeholder="Введите ваше имя"
                  />
                </div>
                <div>
                  <label htmlFor="email" className="block text-sm font-medium text-gray-700 mb-2">
                    Email *
                  </label>
                  <input
                    type="email"
                    id="email"
                    name="email"
                    value={formData.email}
                    onChange={handleChange}
                    required
                    className="w-full px-4 py-3 border border-gray-300 rounded-lg focus:ring-2 focus:ring-green-500 focus:border-transparent text-sm"
                    placeholder="your@email.com"
                  />
                </div>
              </div>

              <div className="grid grid-cols-1 md:grid-cols-2 gap-6">
                <div>
                  <label htmlFor="phone" className="block text-sm font-medium text-gray-700 mb-2">
                    Телефон
                  </label>
                  <input
                    type="tel"
                    id="phone"
                    name="phone"
                    value={formData.phone}
                    onChange={handleChange}
                    className="w-full px-4 py-3 border border-gray-300 rounded-lg focus:ring-2 focus:ring-green-500 focus:border-transparent text-sm"
                    placeholder="+7 (999) 123-45-67"
                  />
                </div>
                <div>
                  <label htmlFor="website" className="block text-sm font-medium text-gray-700 mb-2">
                    Сайт *
                  </label>
                  <input
                    type="url"
                    id="website"
                    name="website"
                    value={formData.website}
                    onChange={handleChange}
                    required
                    className="w-full px-4 py-3 border border-gray-300 rounded-lg focus:ring-2 focus:ring-green-500 focus:border-transparent text-sm"
                    placeholder="https://yoursite.com"
                  />
                </div>
              </div>

              <div>
                <label htmlFor="message" className="block text-sm font-medium text-gray-700 mb-2">
                  Цели и задачи
                </label>
                <textarea
                  id="message"
                  name="message"
                  value={formData.message}
                  onChange={handleChange}
                  rows={4}
                  maxLength={500}
                  className="w-full px-4 py-3 border border-gray-300 rounded-lg focus:ring-2 focus:ring-green-500 focus:border-transparent text-sm resize-none"
                  placeholder="Расскажите о ваших целях в линкбилдинге..."
                />
                <div className="text-right text-sm text-gray-500 mt-1">
                  {formData.message.length}/500
                </div>
              </div>

              <button
                type="submit"
                className="w-full bg-green-600 text-white py-4 px-8 rounded-lg hover:bg-green-700 transition-colors font-medium whitespace-nowrap cursor-pointer"
              >
                Получить анализ ссылок
              </button>
            </form>
          </div>
        </div>
      </section>

      {/* Footer */}
      <footer className="bg-gray-900 text-white py-12">
        <div className="container mx-auto px-6">
          <div className="grid md:grid-cols-4 gap-8">
            <div>
              <Logo className="mb-4 brightness-0 invert" />
              <p className="text-gray-400">
                Профессиональное SEO продвижение сайтов
              </p>
            </div>

            <div>
              <h4 className="font-semibold mb-4">Услуги</h4>
              <ul className="space-y-2 text-gray-400">
                <li><a href="/services/seo-audit" className="hover:text-white transition-colors cursor-pointer">SEO Аудит</a></li>
                <li><a href="/services/linkbuilding" className="hover:text-white transition-colors cursor-pointer">Линкбилдинг</a></li>
                <li><a href="/services/yandex-seo" className="hover:text-white transition-colors cursor-pointer">Продвижение в Яндекс</a></li>
                <li><a href="/services/google-seo" className="hover:text-white transition-colors cursor-pointer">Продвижение в Google</a></li>
              </ul>
            </div>

            <div>
              <h4 className="font-semibold mb-4">Контакты</h4>
              <ul className="space-y-2 text-gray-400">
                <li>+7 (950) 360-35-20</li>
                <li>info@seo-agency.ru</li>
                <li>Москва, ул. Примерная, 123</li>
              </ul>
            </div>

            <div>
              <h4 className="font-semibold mb-4">Социальные сети</h4>
              <div className="flex space-x-4">
                <a href="https://t.me/seo_vektor" className="text-gray-400 hover:text-white transition-colors cursor-pointer">
                  <i className="ri-telegram-fill text-xl"></i>
                </a>
                <a href="https://wa.me/79503603520" className="text-gray-400 hover:text-white transition-colors cursor-pointer">
                  <i className="ri-whatsapp-fill text-xl"></i>
                </a>
                <a href="#" className="text-gray-400 hover:text-white transition-colors cursor-pointer">
                  <i className="ri-youtube-line text-xl"></i>
                </a>
              </div>
            </div>
          </div>

          <div className="border-t border-gray-800 mt-8 pt-8 text-center text-gray-400">
            <p>&copy; 2024 SEO Продвижение. Все права защищены. | 
              <a href="https://readdy.ai/?origin=logo" className="hover:text-white transition-colors cursor-pointer ml-1">
                Website Builder
              </a>
            </p>
          </div>
        </div>
      </footer>
    </div>
  );
};

export default LinkbuildingPage;
